import { useContext } from "react"
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"
import GlobalContext from "../contexts/GlobalContext"

export default function Records(){
    const [globalContext]=useContext(GlobalContext)
    const canSeeConciliations = !!(globalContext && globalContext.profile && globalContext.profile.permissions_granted && globalContext.profile.permissions_granted.find(({alias})=>alias==="master_admin"))
    return(
        <Section>
            <SectionHeader
                title="Cuenta comercial"
                intro="Cargos por uso del servicio y facturación."
                back=""
                button=""
                tabs={[
                    {label:"Transacciones",to:"/c24/actividad"},
                    {label:"Liquidaciones",labelShort:"Liquida...",to:"/c24/actividad/liquidaciones"},
                    ...(canSeeConciliations ? [{label:"Conciliaciones",labelShort:"Concilia...",to:"/c24/actividad/conciliaciones"}] : []),
                    {label:"Cuenta comercial",labelShort:"Cuenta",to:"/c24/actividad/cuenta"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"records",
                    endpoint:"records/list",
                    limit:100,
                    counter:{
                        singular:"registro",
                        plural:"registros"
                    },
                    action:{
                        mode:"",
                        context:"",
                        reference:""
                    }
                }} />
            </SectionContent>
        </Section>
    )
    
}